import { MapPin, Navigation, Clock } from "lucide-react";
import { useEffect, useState } from "react";
import { VENUE } from "@/lib/venue";

export function FooterVenue() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    setReady(true);
  }, []);

  const browserKey = import.meta.env["VITE_GOOGLE_MAPS_API_KEY"] as string | undefined;
  const mapSrc = browserKey
    ? `https://www.google.com/maps/embed/v1/place?key=${encodeURIComponent(browserKey)}&q=${encodeURIComponent(`${VENUE.name}, ${VENUE.address}`)}&zoom=15`
    : `https://www.google.com/maps?q=${encodeURIComponent(`${VENUE.name}, ${VENUE.address}`)}&z=15&output=embed`;

  return (
    <div className="flex h-full flex-col rounded-2xl border border-ink-foreground/10 bg-gradient-to-br from-white/[0.05] to-white/[0.02] p-6 text-center md:text-left">
      <div className="flex flex-col items-center gap-2 md:flex-row md:items-start md:justify-between">
        <h3 className="font-display text-sm font-bold uppercase tracking-widest text-ink-foreground/90">
          Locația evenimentului
        </h3>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-energy/15 px-3 py-1 text-xs font-semibold text-energy">
          <MapPin className="size-3.5" />
          București
        </span>
      </div>

      <div className="mt-5 grid flex-1 gap-5 lg:grid-cols-5">
        {/* Info panel */}
        <div className="flex flex-col justify-between rounded-xl border border-ink-foreground/10 bg-white/[0.03] p-5 lg:col-span-2">
          <div>
            <p className="text-lg font-semibold text-ink-foreground">{VENUE.name}</p>
            <address className="mt-1 not-italic text-sm leading-relaxed text-ink-foreground/60">
              {VENUE.address}
            </address>
          </div>

          <div className="mt-5 space-y-3">
            <div className="hidden items-center gap-3 text-sm text-ink-foreground/70 md:flex">
              <Clock className="size-4 text-energy" />
              <span>6 octombrie 2026</span>
            </div>
          </div>

          <button
            type="button"
            onClick={() => window.open(VENUE.mapsDirectionsUrl, "_blank", "noopener,noreferrer")}
            className="mt-5 inline-flex w-fit items-center gap-2 self-center rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition hover:opacity-90 md:self-start"
          >
            <Navigation className="size-4" />
            Indicații rutiere
          </button>
        </div>

        {/* Map */}
        <div className="min-h-[180px] flex-1 overflow-hidden rounded-xl border border-ink-foreground/10 bg-ink-foreground/5 lg:col-span-3">
          {ready ? (
            <iframe
              title="Hartă Le Château – Castelul din Inima Bucureștiului"
              src={mapSrc}
              className="h-full min-h-[180px] w-full border-0"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          ) : (
            <button
              type="button"
              onClick={() => window.open(VENUE.mapsSearchUrl, "_blank", "noopener,noreferrer")}
              className="grid h-full min-h-[180px] w-full place-items-center gap-2 text-sm text-ink-foreground/70 transition hover:text-energy"
            >
              <MapPin className="size-7 text-energy" />
              Vezi pe Google Maps
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
